import {
  Event,
  relationStatuses,
  SportDetailInputType,
  VolleyballEventDetailId,
} from '@collector/sportsapi-client-legacy'
import { CollectorSport } from '@mobile/reusables/classes/CollectorSport'

import {
  EventPreparationEventDetail,
  EventPreparationEventDetailsSportFactory,
} from './types'
import { getDetailName, getDetailSelectItems } from './utils'

export function eventPreparationEventDetailsVolleyballFactory(
  event: Event,
  sport: CollectorSport,
): EventPreparationEventDetailsSportFactory {
  function getDetails(): EventPreparationEventDetail[] {
    return [
      {
        name: 'Relation status',
        fieldName: 'relation_status',
        type: SportDetailInputType.Select,
        items: relationStatuses,
      },
      {
        id: VolleyballEventDetailId.PossibleGoldenSet,
        name: getDetailName(sport, VolleyballEventDetailId.PossibleGoldenSet),
        type: SportDetailInputType.Select,
        items: getDetailSelectItems(
          event,
          sport,
          VolleyballEventDetailId.PossibleGoldenSet,
        ),
      },
      {
        id: VolleyballEventDetailId.SetsNumber,
        name: getDetailName(sport, VolleyballEventDetailId.SetsNumber),
        type: SportDetailInputType.Select,
        items: getDetailSelectItems(
          event,
          sport,
          VolleyballEventDetailId.SetsNumber,
        ),
      },
      {
        id: VolleyballEventDetailId.ScoringSystem,
        name: getDetailName(sport, VolleyballEventDetailId.ScoringSystem),
        type: SportDetailInputType.Number,
      },
    ]
  }

  return { getDetails }
}
